import React from 'react';
import { createSvgIcon } from '@mui/material';

const CustomBrandsCircular = createSvgIcon(
  <path
    clipRule="evenodd"
    fillRule="evenodd"
    d="M2 12C2 6.47 6.47 2 12 2s10 4.47 10 10-4.47 10-10 10S2 17.53 2 12m10.74-4.9 4.593 4.594a1.04 1.04 0 0 1 .006 1.473l-3.731 3.73a1.04 1.04 0 0 1-1.472 0L7.54 12.303a1.02 1.02 0 0 1-.307-.734V7.84c0-.572.469-1.04 1.041-1.04h3.73c.276 0 .542.109.734.301Zm-3.945 3.04c0 .431.577 1.285 1.01 1.285.43 0 2.056-1.64 2.056-2.072 0-.431-.853-.994-1.285-.994s-1.78 1.349-1.78 1.78Z"
  />,
  'CustomBrandsCircular',
);

export default CustomBrandsCircular;
